'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var classnames = require('classnames');
var React = require('react');
var circleLoader = require('../../loader/circle-loader/circle-loader.js');
require('../../loader/shimmer-loader/shimmer-loader.js');
var td = require('./td.js');
var tr = require('./tr.js');

function _interopDefaultCompat (e) { return e && typeof e === 'object' && 'default' in e ? e : { default: e }; }

var classnames__default = /*#__PURE__*/_interopDefaultCompat(classnames);
var React__default = /*#__PURE__*/_interopDefaultCompat(React);

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
/**
 * `<tr>` which shows `<CircleLoader>`.
 * @param props TrLoaderProps
 * @returns FunctionComponent<TrLoaderProps>
 */ const TrLoader = (props)=>{
    const { breakpoints , className , colSpan , label , loaderProps , look , tdProps , ...otherProps } = props;
    return /*#__PURE__*/ React__default.default.createElement(tr.Tr, _extends({}, otherProps, {
        breakpoints: breakpoints,
        className: classnames__default.default({
            'bf-table__standard-tr-loader': true,
            [`${className}`]: !!className
        }),
        look: look
    }), /*#__PURE__*/ React__default.default.createElement(td.Td, _extends({}, tdProps, {
        breakpoints: breakpoints,
        colSpan: colSpan
    }), /*#__PURE__*/ React__default.default.createElement(circleLoader.CircleLoader, _extends({}, loaderProps, {
        label: label
    }))));
};

exports.TrLoader = TrLoader;
//# sourceMappingURL=tr-loader.js.map
